<template>
  <div class="rd-month">
    <div class="rd-detail__body">
      <dl class="mo-facts">
        <div>
          <dt>{{ $t("makeOrder") }}</dt>
          <dd class="rd-num">#{{ order.id }}</dd>
        </div>
        <div>
          <dt>{{ $t("employee") }}</dt>
          <dd>
            {{ toLatin(order.user_name) }}
            <small class="rd-muted rd-num">ID {{ order.user_id }}</small>
          </dd>
        </div>
        <div>
          <dt>{{ $t("restaurant") }}</dt>
          <dd>{{ toLatin(order.restaurant) }}</dd>
        </div>
        <div v-if="order.delivery_location">
          <dt>{{ $t("delivery_location") }}</dt>
          <dd>{{ toLatin(order.delivery_location) }}</dd>
        </div>
      </dl>

      <ul class="mo-meals">
        <li v-for="(meal, index) in order.meals" :key="index" class="mo-meals__row">
          <span class="mo-meals__name">
            <b class="rd-num">{{ meal.quantity }}×</b> {{ toLatin(meal.name) }}
          </span>
          <report-shift-tag v-if="shiftNumber(meal)" :shift="shiftNumber(meal)"></report-shift-tag>
          <span class="rd-num mo-meals__price">{{ money(meal) }}</span>
        </li>
      </ul>
      <p v-if="order.delivery_notes" class="rd-muted">{{ order.delivery_notes }}</p>
    </div>
  </div>
</template>

<script>
import ReportShiftTag from "@/components/report/shared/ReportShiftTag.vue";

/** Narudžba firme "više restorana" u panelu: radnik, restoran i obroci sa smenom i cenom. */
export default {
  name: "CompanyDesktopMultiOrder",
  components: { ReportShiftTag },
  props: {
    /** Narudžba iz Pakovanja: { id, user_id, user_name, restaurant, meals: [{ name, quantity, shift, price, currency }] } */
    order: { type: Object, required: true },
  },
  methods: {
    shiftNumber(meal) {
      const match = String(meal.shift || "").match(/(\d+)/);
      return match ? Number(match[1]) : null;
    },
    money(meal) {
      return `${(Number(meal.price) || 0).toFixed(2)} ${meal.currency || "KM"}`;
    },
  },
};
</script>
